import React, { useState } from 'react';
import PropTypes from 'prop-types'; // Import PropTypes
import './style.css';

function SubscriptionSideBar(props) {
  const [activeSection, setActiveSection] = useState('Section 1');
  const { setShowSecond, setShowFirst } = props;
  const handleSectionClick = (section) => {
    setActiveSection(section);
  };
  return (
    <div className="Privacy-SideBar-Container">
      <p
        className={`privactSidebar01 ${
          activeSection === 'Section 1' ? 'activeprivacy' : ''
        }`}
        onClick={() => {
          handleSectionClick('Section 1');
          setShowSecond(false);
          setShowFirst(true);
        }}
      >
        Section 1
      </p>
      <p
        className={`privactSidebar01 ${
          activeSection === 'Section 2' ? 'activeprivacy' : ''
        }`}
        onClick={() => {
          handleSectionClick('Section 2');
          setShowFirst(false);
          setShowSecond(true);
        }}
      >
        Section 2
      </p>
      <p
        className={`privactSidebar01 ${
          activeSection === 'Section 3' ? 'activeprivacy' : ''
        }`}
        onClick={() => handleSectionClick('Section 3')}
      >
        Section 3
      </p>
    </div>
  );
}
// Prop types validation
SubscriptionSideBar.propTypes = {
  setShowSecond: PropTypes.func.isRequired,
  setShowFirst: PropTypes.func.isRequired,
};

export default SubscriptionSideBar;
